import type { ReactNode } from "react";
import Icon from "../Icon/Icon";
import type { IconName } from "../Icon/Icon";
import "./Notice.css";

export interface NoticeProps {
  /** info (default), warning, success, danger (something is wrong) */
  tone?: "info" | "warning" | "success" | "danger";
  /** bold first line */
  title?: ReactNode;
  children?: ReactNode;
  /** e.g. a Button on the right */
  action?: ReactNode;
  className?: string;
}

const ICONS: Record<NonNullable<NoticeProps["tone"]>, IconName> = {
  info: "info",
  warning: "warning",
  success: "checkCircle",
  danger: "warning",
};

/**
 * A message that stays on the page (not a toast), e.g. "Waiting for the
 * tenant to set up payment".
 * Example: <Notice tone="warning">Waiting for tenant</Notice>
 */
const Notice = ({
  tone = "info",
  title,
  children,
  action,
  className = "",
}: NoticeProps) => (
  <div
    className={`ds-notice ds-notice--${tone} ${className}`.trim()}
    role="status"
  >
    <Icon name={ICONS[tone]} className="ds-notice__icon" />
    <div className="ds-notice__body">
      {title && <p className="ds-notice__title">{title}</p>}
      {children && <div className="ds-notice__text">{children}</div>}
    </div>
    {action && <div className="ds-notice__action">{action}</div>}
  </div>
);

export default Notice;
